import React, { useEffect } from 'react';
import Layout from '../Layout';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Safreimg from '../../safreeimg/safree_icon.png'

const Admin1Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/admin1') {
      const timer = setTimeout(() => {
        navigate('/admin1/dashboard');
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [location.pathname, navigate]);

  return (
    <div className='mylanding'>
      <Layout>
        {/* Conditional Rendering for Multiple Elements */}
        {location.pathname === '/admin1' && (
          <div className='welcomepage'>
            <img src={Safreimg} alt="" />
            <h1>Safree(Safe And Free)</h1>
            <p>Welcome to Super Admin!</p>
            {/* <NavLink
              to="/admin1/dashboard"
              className={({ isActive }) => (isActive ? 'sidebar-link active' : 'sidebar-link')}
            >
              <button>Go TO Dashboard</button>
            </NavLink> */}
          </div>
        )}
      </Layout>
    </div>
  );
};

export default Admin1Dashboard;
